module.exports = __webpack_public_path__ + "static/media/shape-1-mobile.20b2b7a0.png";